import { newAlertify } from 'trunks/vue/admin/components/alert.js';
import FieldListMixin from 'trunks/vue/share/components/fields/field_list.js';
import { LogicFieldListMixin } from 'trunks/vue/share/mixins/logic_field/index.js';

const ResponseFieldListMixin = Vue.extend({
  mixins: [FieldListMixin, LogicFieldListMixin],

  props: {
    editing: {
      type: Boolean
    }
  },

  render: function(h) {
    return h('div', { class: this.extendClass }, this.fields.map((field) => h(this._getComponent(field), {
      props: {
        field: field,
        entries: this._filterEntries(field),
        response: this.response,
        isAdmin: this.isAdmin,
        key: field.id,
        editing: this.editing,
        disappearedFieldIds: this.disappearedFieldIds
      },
      on: {
        valueChange: this.fieldValueChange,
        childAdded: this.addChildFunc,
        displayAttachment: this.displayAttachmentFunc
      }
    })));
  },

  computed: {
    allFieldsAttachments: function() {
      return _.reduce(this.fieldChildren, (result, childVm) => {
        switch (childVm.field.type) {
          case 'Field::Detail':
            return result.concat(childVm.allGroupsAttachments || []);
          case 'Field::File':
            return result.concat(childVm.value || []);
          default:
            return result;
        }
      }, []);
    }
  },

  methods: {
    _getComponent: function(field) {},

    displayAttachmentFunc: function(attachment) {
      this.$emit('displayAttachment', attachment);
    },

    _alertErrorContent: function(content) {
      newAlertify(content, {
        type: 'error'
      });
    }
  }
});

export default ResponseFieldListMixin;
